export default __webpack_public_path__ + "static/media/img-5.f172d91f.png";